// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3d9385ab","389":"37791f83","455":"902ea6ce","977":"ef569f3a"}[chunkId] + ".chunk.js";
};